import { render } from "./KryptonPopinHeaderLabel.vue?vue&type=template&id=043d5058&lang=pug"
import script from "./KryptonPopinHeaderLabel.vue?vue&type=script&lang=js"
export * from "./KryptonPopinHeaderLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__